import { useSelector, shallowEqual } from 'react-redux';
import { State } from 'src/redux/reducer';

/**
 * Хук-селектор с проверкой необходимости поверхостного сравнения
 *
 * @function
 * @name Hooks.useShallowEqualSelector
 * @param {Function} selector - Селектор для состояния
 * @returns {any}
 */
export function useShallowEqualSelector<T>(selector: (s: State) => T) {
  return useSelector(selector, shallowEqual);
}
